module.exports = __webpack_public_path__ + "static/media/Maf_23Abril.cabae02b.jpg";